import { useContext, useEffect } from 'react';
import { Context } from '../index';

export const useBlockScroll = () => {
    const { contentContainer } = useContext(Context);
    useEffect(() => {
        const target = contentContainer?.current;
        if (target) target.style.overflow = 'hidden';
        return () => {
            if (target) target.style.overflow = 'auto';
        };
    }, []);
};
